import { gql } from '@apollo/client';

export default gql`
  query productTargetsSelect {
    productTargets {
      id
      name
    }
  }
`;
